import { Component, Input } from '@angular/core';

/// Icono de ayuda contextual (pi-info-circle + pTooltip) reutilizable: aparece junto a indicadores,
/// títulos de gráfica y títulos de tabla. Vive en su propio componente para que ese marcado (icono +
/// tooltip + aria-label) se escriba una sola vez, en lugar de repetirse en cada sitio que lo usa.
/// Si no se pasa texto, el icono no se pinta: no todo tiene por qué llevar ayuda.
@Component({
    selector: 'app-platform-health-help-icon',
    templateUrl: './platform-health-help-icon.component.html',
    styleUrls: ['./platform-health-help-icon.component.scss'],
    standalone: false
})
export class PlatformHealthHelpIconComponent {
    @Input() public text: string | null = null;
    @Input() public tooltipPosition: 'top' | 'bottom' | 'left' | 'right' = 'top';
}
